import { render, staticRenderFns } from "./SideBarUpdatesNote.vue?vue&type=template&id=3be3d0c0&scoped=true&"
import script from "./SideBarUpdatesNote.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarUpdatesNote.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be3d0c0",
  null
  
)

export default component.exports